/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Model_Agent_ManagedInputs */



/**
* | output |
* | --- |
* | "Agent model" |
*
* @param {Agent_Builder_Model_Agent_ManagedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_model_agent_managed = /** @type {((inputs?: Agent_Builder_Model_Agent_ManagedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Model_Agent_ManagedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Agentenmodell")
	return /** @type {LocalizedString} */ ("Agent model")
});